export default __webpack_public_path__ + "static/media/pub3.8e3b486f.svg";